<div class="cl-form ls-column">
  <select id="langselect" class="form-select" [(ngModel)]="lastSelected" (ngModelChange)="add($event)">
    <option value="">[Add language]</option>
    @for (l of allLanguages; track l) {
      <option [value]="l.id">{{ l.name }} ({{ l.id }})</option>
    }
  </select>

  <div class="cl-spacing-tiny">
    <div class="animate drag-boundary" cdkDropList (cdkDropListDropped)="drop($event)">
      @for (l of  languages; track l) {
        <div class="line " cdkDrag cdkDragBoundary=".drag-boundary">
          <div class="placeholder" *cdkDragPlaceholder></div>
          <div class="ls-row">
            <div>
              <i class="fas fa-solid fa-grip-lines ls-grip" aria-hidden="true"></i>
            </div>
            <div class="ls-name">
              {{ l | langName }} ({{ l }})
            </div>
            <div><a role="button" [routerLink]="" class="cl-a-quickaction" (click)="remove(l)">Remove</a></div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="ls-fill"></div>
</div>
